/*
 * @Name 角色权限校验
 *
 * check() 方法传入权限码，通过权限码判断是否拥有某个权限 返回值 true/false
 * isTourists()  是否为游客  返回值 true/false
 * isCasual()  是否为散客  返回值 true/false
 * isGuest()  是否为客户经理  返回值 true/false
 * checkRole() 根据角色名判断是否为某个角色  返回值 true/false
 */
import store from '../store/index'
import * as perCode from './PermissionCode.js'
const roleCheck = {

    /**
     * 获得当前登录人的权限码清单
     * 数据有做处理，根据 $ 符号切割，移除第一个符号及前面部分，保留后面部分
     * 接口拿到的权限如下格式 eventsgocommon$Service$Security.operation$delete 移除 第一个 $符号前面的内容
     */
    getPrivilegeDataSync() {
        let currUser = store.state.common.user
        let permissionsData = currUser.currentRole.personalPermissions
        return permissionsData
    },

    /**
     * 根据权限码判断是否有这个权限（跟AUI的权限校验保持一致）
     * @param {*} expression 权限码
     */
    check(expression) {
        if (expression && typeof expression === 'string') {
            var perms = this.getPrivilegeDataSync()
            return perms.indexOf(expression) !== -1
        }
        return false
    },

    /**
     * 校验当前登录的角色中是否为单一的一线接口人
     */
    isRoleContactPerson() {
        let flag = false
        let currUser = store.state.common.user
        let currentRoleArr = currUser.validRoles || []
        if (currentRoleArr.length && currentRoleArr.length === 1) {
            flag = currentRoleArr[0].roleName === '一线接口人'
        }
        return flag
    },

    /**
     * 校验是否为游客
     */
    isTourists() {
        let flag = false
        let currUser = store.state.common.user
        let currentRoleArr = currUser.validRoles || []
        if (currentRoleArr.length) {
            flag = currentRoleArr.some(item => item.roleName === 'Tourists')
        }
        return flag
    },

    /**
     * 校验是否为散客
     */
    isCasual() {
        let flag = false
        let currUser = store.state.common.user
        let currentRoleArr = currUser.validRoles || []
        if (currentRoleArr.length) {
            flag = currentRoleArr.some(item => item.roleName === 'Casual')
        }
        return flag
    },

    /**
     * 校验是否为客户经理
     */
    isGuest() {
        let flag = false
        if (!this.isTourists() && !this.isCasual()) { flag = true }
        return flag
    },

    /**
     * 校验是否为系统管理员(根据角色判断)
     */
    isSystemAdminByRole() {
        let currUser = store.state.common.user
        let currentRoleArr = currUser.validRoles || []
        return currentRoleArr.some(item => ['系统管理员(System Admin-ATE)', '系统管理员(System Admin-BTE)', 'System Admin'].some(key => item.roleName === key))
    },

    /**
     * 校验是否为PM
     */
    isPM() {
        let currUser = store.state.common.user
        let currentRoleArr = currUser.validRoles || []
        return currentRoleArr.some(item => item.roleName === '项目经理(Project Manager)')
    },

    /**
     * 校验是否为配置管理员(根据角色判断)
     */
    isConfigureAdminByRole() {
        let currUser = store.state.common.user
        let currentRoleArr = currUser.validRoles || []
        return currentRoleArr.some(item => item.roleName === '配置管理员(Configure Admin-ATE)' || item.roleName === '配置管理员(Configure Admin-BTE)')
    },

    /**
     * 校验是否为机票科负责人
     */
    isAirPlaneResponsiblePerson() {
        let currUser = store.state.common.user
        let currentRoleArr = currUser.validRoles || []
        return currentRoleArr.some(item => item.roleName === '机票科负责人')
    },

    /**
     * 校验是否为一级组织接口人
     */
    isLevel1OrgContact() {
        let currUser = store.state.common.user
        let currentRoleArr = currUser.validRoles || []
        return currentRoleArr.some(item => item.roleName === '一级组织接口人')
    },

    /**
     * 校验是否为一级组织接口人
     */
    isLevel2OrgContact() {
        let currUser = store.state.common.user
        let currentRoleArr = currUser.validRoles || []
        return currentRoleArr.some(item => item.roleName === '二级组织接口人')
    },
    // 展会管理员
    isExhiManger() {
        const currentRoleArr = store.state.common.user.validRoles || []
        return currentRoleArr.some(item => item.roleName === '展会管理员(Events Admin)')
    },
    // 报名资源管理员
    isRegistManager() {
        const currentRoleArr = store.state.common.user.validRoles || []
        return currentRoleArr.some(item => item.roleName === '报名资源管理员')
    },
    /** 业务侧管理员，对爱上会平台上的展会进行提前配置（业务描述配置管理员） */
    judgmentIsExhiMange() {
        return this.check(perCode.FIND_EXHI_PAGED_LIST)
    },

    /** IT侧管理员，用户角色管理，对爱上会平台上的角色、权限、字段、属性、集成接口处理等（业务描述系统管理员） */
    judgmentIsSystemAdmin() {
        return this.check(perCode.FIND_USER_PERMISSIONS)
    }
}
export default roleCheck
